import HelmetWrapper from './HelmetWrapper.component';

export default HelmetWrapper;
